import type { ReactNode } from "react";

import { Flex } from "@radix-ui/themes";

export interface MenuRowPresentationProps {
  isActive: boolean;
  isHovered: boolean;
  label: string;
  contentAlign?: "center" | "start";
  onHoverChange: (hovered: boolean) => void;
  onSelect: () => void;
  children: ReactNode;
}

export const MenuRowPresentation = ({
  isActive,
  isHovered,
  label,
  contentAlign = "center",
  onHoverChange,
  onSelect,
  children,
}: MenuRowPresentationProps) => {
  return (
    <Flex
      role="menuitem"
      tabIndex={-1}
      className="group-select-row"
      aria-label={label}
      aria-selected={isActive}
      data-selected={isActive ? "" : undefined}
      data-hovered={isHovered ? "" : undefined}
      px="2"
      py="1"
      onMouseEnter={() => onHoverChange(true)}
      onMouseLeave={() => onHoverChange(false)}
      onClick={(event) => {
        const target = event.target as HTMLElement | null;
        if (target?.closest("button, input, [data-group-nested]")) {
          return;
        }
        onSelect();
      }}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onSelect();
        }
      }}
    >
      <Flex align={contentAlign} gap="2" width="100%">
        {children}
      </Flex>
    </Flex>
  );
};
